// QuickActions.js
// "Quick actions" card: the lesson finder (when the lesson_plan flag is on)
// plus three shortcut pills for the teacher's most common next steps.
// See docs/superpowers/specs/2026-09-16-home-redesign.md §5.
import React from "react";
import { View, StyleSheet } from "react-native";

import HomeCard from "../primitives/HomeCard";
import HomePill from "../primitives/HomePill";
import LessonPlanLauncher from "../../lessonPlans/LessonPlanLauncher";

const identity = (s) => s;

const QuickActions = ({
  showLessonFinder = false,
  lessonFinderProps = {},
  onCreateTest,
  onAddStudent,
  onViewKnowledgeInsights,
  onViewStudentHome = null,
  isDarkMode = false,
  t = identity,
}) => (
  <HomeCard title={t("Quick actions")} isDarkMode={isDarkMode} testID="quick-actions">
    {showLessonFinder ? (
      <View style={styles.lessonFinder} testID="quick-actions-lesson-finder">
        <LessonPlanLauncher {...lessonFinderProps} isDarkMode={isDarkMode} t={t} />
      </View>
    ) : null}
    <View style={styles.pillRow}>
      <HomePill
        icon="clipboard-plus-outline"
        label={t("Create a test")}
        onPress={onCreateTest}
        isDarkMode={isDarkMode}
        testID="quick-actions-create-test"
      />
      <HomePill
        icon="account-plus-outline"
        label={t("Add students")}
        onPress={onAddStudent}
        isDarkMode={isDarkMode}
        testID="quick-actions-add-student"
      />
      <HomePill
        icon="chart-timeline-variant"
        label={t("Insights")}
        onPress={onViewKnowledgeInsights}
        isDarkMode={isDarkMode}
        testID="quick-actions-insights"
      />
      {typeof onViewStudentHome === "function" ? (
        <HomePill
          icon="account-eye-outline"
          label={t("See the student home")}
          onPress={onViewStudentHome}
          isDarkMode={isDarkMode}
          testID="quick-actions-view-student-home"
        />
      ) : null}
    </View>
  </HomeCard>
);

const styles = StyleSheet.create({
  lessonFinder: { marginBottom: 14 },
  pillRow: { flexDirection: "row", flexWrap: "wrap", gap: 10 },
});

export default QuickActions;
